import { StrictMode } from 'react'
import { App } from './App.tsx'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from './context/ThemeContext.tsx'
import { queryClient } from './lib/react-query.ts'

import './index.css'
import './menu.css'
import './phrases.css'
import './animate.css'

createRoot(document.getElementById('root')!).render(
 <StrictMode>
  <QueryClientProvider client={queryClient}>
   <ThemeProvider>
    <App />
   </ThemeProvider>
  </QueryClientProvider>
 </StrictMode>
)
